import React from 'react';
import styled from 'styled-components';
import Row, { AutoRow, RowBetween } from '../Row';
import {
    Logo,
    TelegramIcon,
    CnTelegramIcon,
    TwitterIcon,
    LinkedinIcon,
    DiscordIcon,
    YoutubeIcon,
} from 'common-helpers/img';
import Column, { AutoColumn } from 'components/Column';
import { TYPE } from 'theme';
import { StyledMainContainer } from 'components/styled/Box';
import { isMobile } from 'react-device-detect';

const FooterWrapper = styled.div`
    width: 100%;
    padding: 100px 50px;
    background-color: #000;
    &:not(.full) {
        min-width: 1240px;
    }

    a {
        text-decoration: none;
    }

    ${({ theme }) => theme.mediaWidth.upToMedium`
        padding-bottom: 80px;
    `};
    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 50px 30px 80px;
        min-width: unset !important;
    `};
`;

const LogoSVG = styled(Logo)`
    width: 200px;
    height: 48px;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 150px;
    `};
`;

const MediaWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    flex-direction: row;
    a {
        svg {
            width: 24px;
            height: 24px;
            color: #c4c4c4;

            ${({ theme }) => theme.mediaWidth.upToMedium`
                width: 20px;
                height: 20px;
            `};
        }
        &:hover {
            scale: 0.9;
            opacity: 0.6;
        }
    }
`;

const LinkColumn = styled(AutoColumn)`
    gap: 30px;
    width: fit-content;
    justify-content: flex-start;
    a {
        text-decoration: none;
        color: #fff;
        font-size: 14px;
        text-transform: uppercase;

        ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 12px;
        `};

        &:hover {
            opacity: 0.6;
        }
    }
`;

const SubContent = styled(AutoColumn)`
    margin-top: 60px;
    padding: 20px 0;
    border-top: 1px solid #c4c4c47a;
    color: #acacac;
    a {
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
        &:hover {
            opacity: 0.6;
        }
    }

    ${({ theme }) => theme.mediaWidth.upToMedium`
        margin-top: 20px;
    `};
`;

const PolicyRow = styled(Row)`
    gap: 8px;
    a {
        flex-shrink: 0;
    }
    ${({ theme }) => theme.mediaWidth.upToSmall`
        order: 1;
    `};
`;

const BottonRow = styled(RowBetween)`
    gap: 20px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        gap: 12px;
        flex-direction: column;
        align-items: flex-start;
    `};
`;

const MainRow = styled(AutoRow)`
    gap: 30px;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        flex-direction: column;
    `};
`;

export default function Footer({ className }: { className?: string }) {
    return (
        <FooterWrapper className={className}>
            <StyledMainContainer>
                <MainRow align="stretch" justify="space-between">
                    <Column gap="lg">
                        <a href="https://www.goat.network" target="_blank" rel="noreferrer">
                            <LogoSVG />
                        </a>
                        <MediaWrapper>
                            <a href="https://t.me/GOATrollup" target="_blank" rel="noreferrer">
                                <TelegramIcon />
                            </a>
                            <a href="https://t.me/GOAT_CN" target="_blank" rel="noreferrer">
                                <CnTelegramIcon />
                            </a>
                            <a href="https://twitter.com/GOATrollup" target="_blank" rel="noreferrer">
                                <TwitterIcon />
                            </a>
                            <a
                                href="https://www.linkedin.com/company/goatrollup/?viewAsMember=true"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <LinkedinIcon />
                            </a>
                            <a href="https://discord.com/invite/goatnetworkofficial" target="_blank" rel="noreferrer">
                                <DiscordIcon />
                            </a>
                            <a href="https://www.youtube.com/@GOATRollup" target="_blank" rel="noreferrer">
                                <YoutubeIcon />
                            </a>
                        </MediaWrapper>
                    </Column>
                    <LinkColumn>
                        <a href="https://www.goat.network/ecosystem" target="_blank" rel="noreferrer">
                            ECOSYSTEM
                        </a>
                        <a href="https://docs.goat.network/" target="_blank" rel="noreferrer">
                            DOCS
                        </a>
                        <a href="https://www.goat.network/blog" target="_blank" rel="noreferrer">
                            BLOG
                        </a>
                    </LinkColumn>
                    <LinkColumn>
                        <a href="https://www.goat.network/events" target="_blank" rel="noreferrer">
                            EVENTS
                        </a>
                        <a href="https://www.goat.network/brand-assets" target="_blank" rel="noreferrer">
                            BRAND ASSETS
                        </a>
                        {!isMobile ? (
                            <a
                                style={{ visibility: 'hidden' }}
                                href="https://drive.google.com/file/d/10ewS2mEkR-2F6wPnR-rVc0_wEJG6xeOA/view"
                                target="_blank"
                                rel="noreferrer"
                            >
                                BRAND GUIDELINES
                            </a>
                        ) : null}
                    </LinkColumn>
                    <div></div>
                </MainRow>

                <SubContent>
                    <BottonRow>
                        <PolicyRow>
                            <a href="https://www.goat.network/termsofuse" target="_blank" rel="noreferrer">
                                <TYPE.main fontSize={14} color="#6C6C6C">
                                    Terms of Use
                                </TYPE.main>
                            </a>
                            <span>|</span>
                            <a href="https://www.goat.network/privacy" target="_blank" rel="noreferrer">
                                <TYPE.main fontSize={14} color="#6C6C6C">
                                    Privacy Policy
                                </TYPE.main>
                            </a>
                        </PolicyRow>
                    </BottonRow>
                </SubContent>
            </StyledMainContainer>
        </FooterWrapper>
    );
}
